export default {
   /*setActualPlatforms: (state,payload) => {
      state.platforms = payload;
   },*/
}